"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: subheadlineRef,
    isVisible: subheadlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-dark-background text-foreground-dark !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1536434/img/valletta_skyline_hero.png)]">
      
      {}
      <div className="absolute inset-0 bg-dark-background/60" aria-hidden="true" />

      {}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {}
        <h1 ref={headlineRef} className="font-display text-4xl font-bold mb-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] opacity-100 translate-y-0 !text-[hsl(210,40%,98%)] sm:text-5xl md:text-6xl lg:text-7xl">
          Malta Dental Specialists Association
        </h1>

        {}
        <p ref={subheadlineRef} className="text-lg mb-8 max-w-2xl mx-auto transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 opacity-100 translate-y-0 !text-[hsl(210,40%,98%)] sm:text-xl md:text-2xl">Advancing dental excellence through professional collaboration, continuing education, and community engagement across Malta and Gozo.</p>

        {}
        <div ref={ctaRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-[200ms] ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Button asChild size="lg" className="bg-primary text-foreground-primary hover:bg-primary-hover active:bg-primary-active transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] hover:scale-105 hover:shadow-medium focus-ring">
            <Link to="/MembershipPage">Join MDSA</Link>
          </Button>
        </div>
      </div>
    </section>;
}